<div [ngClass]="tooltipPosition" class="flex-gap-5">
  <div class="custom-control custom-switch custom-switch-lg">
    <input
      type="checkbox"
      class="custom-control-input"
      tabindex="0"
      [id]="id"
      [ngModel]="model"
      (ngModelChange)="onNgModelChange($event)"
      [attr.data-track-category]="trackCategory"
      [attr.data-track-action]="trackAction"
      [disabled]="inputDisabled"
    />
    <label class="custom-control-label mb-1" [for]="id" [ngClass]="classesString">
      {{ label | translate }}
    </label>
  </div>
  <div>
    <info-tooltip
      class="align-self-center"
      *ngIf="tooltipLabel && tooltipLabel.length > 0"
      [label]="tooltipLabel"
      [icon]="tooltipIcon"
    ></info-tooltip>
    <div *ngIf="!control.pristine && !control.valid" style="color: #f0142f">
      {{ errors | formError: formControlName | translate }}
    </div>
  </div>
</div>
